export const publishablePlatforms = ['xiaohongshu', 'douyin', 'wechat', 'kuaishou']

export const publicationStatusLabels = {
  available: '可发布',
  scheduled: '已排期',
  published: '已发布',
}

export function normalizeTemplatePlatforms(platforms) {
  return [...new Set((Array.isArray(platforms) ? platforms : []).filter(platform => publishablePlatforms.includes(platform)))]
}

export function getPublicationId(assetId, platform) {
  return `asset-publication-${assetId}-${platform}`
}

export function createPublicationMap(publications) {
  return new Map(publications.map(publication => [`${publication.assetId}:${publication.platform}`, publication]))
}

export function getAssetPlatformStates(asset, template, publicationMap) {
  return normalizeTemplatePlatforms(template?.platforms).map(platform => {
    const publication = publicationMap.get(`${asset.id}:${platform}`)
    return {
      platform,
      status: publication?.status === 'published' ? 'published' : publication?.status === 'scheduled' ? 'scheduled' : 'available',
      publication,
    }
  })
}
